module.exports = __webpack_public_path__ + "static/img/katakura_06.6808df9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/katakura_06.jpg
// module id = MZ4j
// module chunks = 0